import React, { FC, memo } from "react";
import ReactDOM from "react-dom";

import Button from "~/shared/ui/Fields/Button";

import Close from "~/components/Icons/Close";
import s from "./styles.less";

interface Props {
  title: string;
  handleClose?: () => void;
  children: any;
}

const NotificationRight: FC<Props> = ({
  title = "",
  handleClose,
  children,
}) => {
  return ReactDOM.createPortal(
    <div className={s.notification_right}>
      <div className={s.header}>
        {title}
        {handleClose && (
          <Button onlyIcon onClick={handleClose}>
            <Close />
          </Button>
        )}
      </div>
      <div className={s.body}>{children}</div>
    </div>,
    document.getElementById("notifications")
  );
};

export default memo(NotificationRight);
